import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import Grid from '../../../../../SharedModules/Table/tableGrid';
import TableFilterHeader from '../../../../contactType/components/TableFilterHeader';
import { BOTTOM_GRID_TABLEHAD } from '../gridComponents/tableHead';
import { handleQuarterFormate } from '../../../../../SharedModules/CommonUtilities/commonUtilities';
const BottomGridTable = ({
  showFullScreen = true,
  fullScreen,
  setFullScreen,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const bottomGridTableData = useSelector(
    (state) => state.sharedState.URASearchReducer.bottomGridTableData
  );

  const childRef = useRef(null);
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [applyFilter, setApplyFilter] = useState(false);

  const resetFilters = () => {
    gridApi && gridApi.setFilterModel(null);
  };

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
  }, []);

  useEffect(() => {
    resetFilters();
    let mappedObj = bottomGridTableData?.map((obj) => {
      obj.calcQtr = handleQuarterFormate(obj.calcQtr);
      obj.targetQtr = handleQuarterFormate(obj.targetQtr);
      return obj;
    });
  }, [gridApi, bottomGridTableData]);
  return (
    <>
      <TableFilterHeader
        gridApi={gridApi}
        columnApi={columnApi}
        childRef={childRef}
        showFullScreen={showFullScreen}
        applyFilter={applyFilter}
        fullScreen={fullScreen}
        setFullScreen={setFullScreen}
        showExport={true}
        showHistory={false}
        exportFile
        fileName={'NDC Details'}
        resetFilterFunc={resetFilters}
        className="mt-2 mb-1 border-bottom"
      />
      <div className="table-container eightRecords">
        <Grid
          ref={childRef}
          gridHeight={fullScreen ? '100vh' : 200}
          rowData={bottomGridTableData ?? []}
          columnDefs={BOTTOM_GRID_TABLEHAD}
          defaultCol={{ editable: false }}
          onGridReady={onGridReady}
          onFilterChanged={(e) => {
            if (
              (e.api.getFilterModel() && Object.keys(e.api.getFilterModel()))
                .length > 0
            ) {
              setApplyFilter(true);
            } else {
              setApplyFilter(false);
            }
          }}
        />
      </div>
    </>
  );
};

export default BottomGridTable;
